import { render, staticRenderFns } from "./CarouselInforme.vue?vue&type=template&id=f7d0af4a&"
import script from "./CarouselInforme.vue?vue&type=script&lang=js&"
export * from "./CarouselInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCarousel,
  VCarouselItem,
  VExpandTransition,
  VFlex,
  VHover,
  VIcon,
  VImg,
  VLayout,
})
